export default __webpack_public_path__ + "static/media/total.da1777f5.svg";